import jsPDF from "jspdf";
import { DateTime } from "luxon";
import numeral from "numeral";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../../_store/userStore";
import { MTButton } from "../../components/button/MTButton";
import { HeaderTitle } from "../../components/header/Header";
import Container from "../../components/layout/Container";
import { PopupMain } from "../../components/popup/PopupMain";
import { NavigatePath } from "../../functions/Navigate.Goback";
import { ICON_DL_PDF, ICON_LOADING } from "../../utils/useIcons";
import { PdfContext } from "../pdf/context/pdf.ctx";
import PDFRender from "../pdf/pdf.render";
import { CardMenuReport } from "./components/cardMenu";
import { OPTION_MENU_REPORT } from "./constrant/constrant.main";

function ReportMain({ date = "DD/MM/YYYY เวลา 12:00 น." }) {
  const navigate = useNavigate();

  const [isSubmit, setIsSubmit] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const userData = useUserStore((state) => state.userData);

  const [progress, setProgress] = useState(0);
  const [allPages, setAllPages] = useState(0);

  const pdfCtx = useContext(PdfContext);

  const doc = useMemo(() => {
    return new jsPDF("p", "px", "a4");
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // for smooth scrolling
    });
    setTimeout(() => {
      setLoadingPage(false);
    }, 500);
    const input = document.getElementById("pdf-content");
    const pages = input.querySelectorAll(".page");
    setAllPages(pages.length + 2);
  }, []);

  useEffect(() => {
    if (isSubmit) {
      doc.save("รายงานสรุป.pdf");
      setLoadingPDF(false);
    }
  }, [isSubmit]);

  const onClickDownload = async () => {
    try {
      navigate("/pdf");
     
    } catch (error) {
      console.log("error", error);
    }
  };

  const getDate = () => {
    if (pdfCtx?.pdfDate) {
      const pdfJsDate = new Date(pdfCtx?.pdfDate);
      const fullDate = DateTime.fromJSDate(pdfJsDate).toFormat("dd/MM/yyyy");
      const time = DateTime.fromJSDate(pdfJsDate).toFormat("HH:mm");
      return `${fullDate} เวลา ${time} น.`;
    }
    return date;
  };

  return (
    <Container className={"overflow-auto bg-white"}>
      {!loadingPage ? (
        <div className=" pt-[14px]">
          <HeaderTitle
            title="รายงาน"
            isGoback
            onClickGoBack={() => {
              NavigatePath(navigate, "/");
            }}
          />
          <div className="text-maincyan font-medium text-center text-xl mt-5">
            รายงานผลการเงินส่วนบุคคล
          </div>
          <div className=" px-[25px] mt-8">
            {OPTION_MENU_REPORT?.map((item, index) => {

              if (index === 0) {
                <div key={index} className="">
                  <CardMenuReport
                    key={index}
                    icon={item.icon}
                    title={item.title}
                    onClick={() => {
                      navigate(item?.path);
                    }}
                  />
                </div>
              }

              return (
                <div key={index} className="">
                  <CardMenuReport
                    key={index}
                    icon={item.icon}
                    title={item.title}
                    onClick={() => {
                      navigate(item?.path);
                    }}
                  />
                </div>
              );
            })}
          </div>
          <div className="mt-10 flex justify-center mb-[33px]">
            <MTButton
              flexnone="-ml-4"
              loading={loadingPDF}
              onClick={onClickDownload}
              text="ดาวน์โหลด"
              color=" bg-white border border-maincyan hover:bg-maincyan hover:text-white group "
              colortext="text-maincyan font-medium group-hover:text-white "
              iconleft
              icon={
                <ICON_DL_PDF className="w-4 h-4 text-maincyan group-hover:text-white ml-4" />
              }
            />
          </div>
          <PopupMain
            img={false}
            open={loadingPDF}
            isHasButton={false}
            text={
              <div>
                <ICON_LOADING className=" w-14 h-14 mx-auto text-maincyan" />
                {numeral((progress / allPages) * 100).format("0.00")}/100 %
                <div className=" mt-4 font-semibold text-mainblue flex flex-col items-center justify-center">
                  {" "}
                  <div>กำลังดาวน์โหลดรายงาน</div>
                  <div>กรุณาอยู่หน้านี้จนกว่าจะดาวน์โหลดเสร็จสิ้น</div>
                </div>
              </div>
            }
          />
        </div>
      ) : null}
      <PDFRender />
    </Container>
  );
}

export default ReportMain;
